module.exports = __webpack_public_path__ + "static/media/iconImport.db06e95a.svg";